import React from 'react'
import { useNavigate } from 'react-router-dom'
import { AuthRequired } from '@jana-technology/platform-ui'

/**
 * Wrapper around ~React Router's Route~ component to verify user
 * authentication status before rendering the route.
 *
 * @param props - react router props incl. element
 */
const ProtectedRoute = ({ children }: React.PropsWithChildren) => {
  const navigate = useNavigate()

  if (children == null) {
    return <div>ProtectedRoute has no children to render!</div>
  }

  return (
    <AuthRequired
      onAuthentication={() => {
        // bail if authentication required - redirect to login landing page instead
        const pathname = globalThis.location?.pathname ?? '/'
        const search = globalThis.location?.search ?? ''
        const returnTo = `${pathname}${search}`
        navigate(`/login?returnTo=${returnTo}`)
      }}
    >
      {children}
    </AuthRequired>
  )
}

export default ProtectedRoute
